import React, { useState } from "react";
import {
  getGender,
  getGermanLanguageLevelForStudent,
  getKnowledgeLevel,
  getSpecialNeeds,
  getHelpWithStudy,
} from "@helpers/getGermanNaming";

import * as S from "./styles";

interface Props {
  student: any;
  paperProps?: any;
  handleClose: () => void;
  anchorEl: any;
  id: any;
}

const StudentHint = ({ student, paperProps, handleClose, anchorEl }: Props) => {
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <S.PopoverWrap
      PaperProps={paperProps}
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
    >
      <S.HintWrap>
        <S.HintHeader>SuS-Information</S.HintHeader>
        <S.HintRow>
          <S.HintItem>
            <p className="label">Name</p>
            <strong>{student?.fullName || ""}</strong>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Adresse</p>
            <span>{student.address}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Freunde</p>
            <span>{student?.bestFriendName}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Geschlecht</p>
            <span>{getGender(student.gender)}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Lehrperson</p>
            <span>{student?.teacherName}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Letzte Lehrperson</p>
            <span>{student?.teacher}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Deutsch</p>
            <span>{getGermanLanguageLevelForStudent(student.germanLanguageLevel)}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Anforderungen</p>
            <span>{getKnowledgeLevel(student?.knowledgeLevel)}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Anforderungen wurde abgeklärt</p>
            <span>{student?.knowledgeLevelNote}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Anforderungen Grund</p>
            <span>{student?.knowledgeLevelSpecialNote}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">InS</p>
            <span>{student?.inS}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Fördermassnahmen</p>
            <span style={{ display: 'flex', flexDirection: 'column' }}>
              {student?.specialNeeds.map((need) => <span>{getSpecialNeeds(need)}</span>)} 
            </span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Fördermassnahmen Weitere</p>
            <span>
              {student?.specialNeedsNote}
            </span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Lernbegleitung SHP </p>
            <span style={{ display: 'flex', flexDirection: 'column' }}>
              {student?.helpWithStudy.map((value) => <span>{getHelpWithStudy(value)}</span>)}
            </span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Bemerkungen</p>
            <span>{student?.note}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Stärken / Ressource</p>
            <span>{student?.specialNote}</span>
          </S.HintItem>
        </S.HintRow>
      </S.HintWrap>
    </S.PopoverWrap>
  );
};

export default StudentHint;
